import { limit as limitFirebase, orderBy, where } from "firebase/firestore"
import { default as moment, default as Moment } from 'moment'
import { Collection, WhereField } from '../../shared/constants'
import { isNullOrEmpty } from '../../shared/utils'
import { addDoc, deleteDoc, getAllDocsByClientId, getAllDocsByQueries, getCountByQueries, getDocById, getDocByQueries, updateDoc } from './collectionBaseWorker'

export const getAllNewNotesByClientId = async ({ clienteId }) => {
    return await getAllDocsByClientId({ collection: Collection.NEW_NOTE, clienteId: clienteId })
}

export const getNewNotesByParkId = async ({ parkId, days, status, type }) => {
    const results = await getAllDocsByQueries({
        collection: Collection.NEW_NOTE,
        queries: [
            where(WhereField.PARKID, '==', parkId),
            where(WhereField.CREATED_AT, '>=', Moment().startOf('day').toDate()),
            where(WhereField.CREATED_AT, '<=', Moment().endOf('day').toDate()),
            !isNullOrEmpty(status) && where(WhereField.CURRENT_STATUS, '==', status),
            !isNullOrEmpty(type) && where(WhereField.TYPE, '==', type),
            orderBy(WhereField.CREATED_AT, 'desc')
        ]
    })
    return results.sort((a, b) => b.createdAt.toDate() - a.createdAt.toDate())
}

export const getNewNotesInRangeByParksIds = async ({ estacionamentosIds, startDate, endDate, status, type, limit }) => {
    const newStartDate = Moment(startDate).startOf('day').toDate()
    const newEndDate = Moment(endDate).endOf('day').toDate()
    const chunkSize = 10;
    const result = []
    for (let i = 0; i < estacionamentosIds.length; i += chunkSize) {
        const estacionamentosSliced = estacionamentosIds.slice(i, i + chunkSize);
        if (estacionamentosSliced.length > 0) {
            const results = await getAllDocsByQueries({
                collection: Collection.NEW_NOTE,
                queries: [
                    where(WhereField.PARKID, 'in', estacionamentosSliced.slice(0, 10)),
                    where(WhereField.CREATED_AT, '>=', newStartDate),
                    where(WhereField.CREATED_AT, '<=', newEndDate),
                    !isNullOrEmpty(status) && where(WhereField.CURRENT_STATUS, '==', status),
                    type !== "Todos" && where(WhereField.TYPE, '==', type),
                    limitFirebase(limit ?? 10),
                ]
            })
            result.push(...results)
        }
    }
    console.log(result)
    return result.sort((a, b) => b.createdAt?.toDate() - a.createdAt?.toDate())
}

export const getAllGeneratedNotesInCurrentMonth = async ({ parkId }) => {
    const startOfMonth = moment().startOf('month')
    const endOfMonth = moment().endOf('month')
    return await getAllDocsByQueries({
        collection: Collection.NEW_NOTE,
        queries: [
            where(WhereField.PARKID, '==', parkId),
            where(WhereField.CREATED_AT, '>=', startOfMonth.toDate()),
            where(WhereField.CREATED_AT, '<=', endOfMonth.toDate())
        ]
    })
}

export const getAllByRessaleId = async ({ ressaleId, limit }) => {
    return await getAllDocsByQueries({
        collection: Collection.NEW_NOTE,
        queries: [
            where(WhereField.REVENDAID, '==', ressaleId),
            orderBy(WhereField.CREATED_AT, 'desc'),
            limitFirebase(limit ?? 5)
        ]
    })
}

export const getAllChargeNotesByRessaleId = async ({ ressaleId }) => {
    const results = await getAllDocsByQueries({
        collection: Collection.NEW_NOTE,
        queries: [
            where(WhereField.REVENDAID, '==', ressaleId),
            where(WhereField.TYPE, '==', "cobranca"),
            limitFirebase(200)
        ]
    })
    return results.sort((a, b) => b.createdAt.toDate() - a.createdAt.toDate())
}

export const getNewNoteById = async ({ id }) => {
    return await getDocById({ collection: Collection.NEW_NOTE, id: id })
}

export const updateNewNoteById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.NEW_NOTE, id: id, data: data })
}

export const deleteNewNoteById = async ({ id }) => {
    await deleteDoc({ collection: Collection.NEW_NOTE, id: id })
}

export const addNewNote = async ({ data }) => {
    data.origin = "admin"
    const doc = await addDoc({ collection: Collection.NEW_NOTE, data: data })
    data.id = doc.id
    return data
}

export const getNewNoteByIdentifier = async ({ identifier }) => {
    return await getDocByQueries({
        collection: Collection.NEW_NOTE,
        queries: [
            where(WhereField.IDENTIFIER, "==", identifier)
        ]
    })
}

export const getCountNotesByParkIdAndDates = async ({ estacionamentoId, startDate, endDate }) => {
    return await getCountByQueries({
        collection: Collection.NEW_NOTE,
        queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            where(WhereField.CREATED_AT, '>=', startDate),
            where(WhereField.CREATED_AT, '<=', endDate)
        ]
    })
}